export default [
  "hotel",
  "hostel",
  "bed and breakfast",
  "apartment",
  "resort",
  "motel",
  "boutique hotel",
  "bungalow",
  "cabin",
  "campground",
  "guesthouse",
  "guest accommodation",
  "historic hotel",
  "inn",
  "lodge",
  "pension",
  "residence",
  "ryokan",
];



// WEBPACK FOOTER //
// ./assets/list/constants/lodgingTypes.js